import './Settings.css';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import SystemSetUp from './components/SystemSetUp';
import AlertSetUp from './components/AlertSetUp';
import AlertTargetManagement from './components/AlertTargetManagement';
const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('t') || 'system');
  const updateSearchParams = (newParams) => {
    const current = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...current, ...newParams });
  };  
  useEffect(() => {
    setActiveTab(searchParams.get('t') || 'system');
  }, [searchParams]);

  return (
    <div className="settings-container page-container">
      <div className="tabs grid-cols-3 w-half">
        <button 
          className={`tab ${activeTab === 'system' ? 'active' : ''}`}
          onClick={() => updateSearchParams({ t: 'system' })}
        >
          시스템 구성
        </button>
        <button 
          className={`tab ${activeTab === 'alert' ? 'active' : ''}`}
          onClick={() => updateSearchParams({ t: 'alert' })}
        >
          알림 규칙 설정
        </button>
        <button 
          className={`tab ${activeTab === 'alertTarget' ? 'active' : ''}`}
          onClick={() => updateSearchParams({ t: 'alertTarget' })}
        >
          알림 대상 관리
        </button>
      </div>
      <div className="settings-content">
        {activeTab === 'system' && (
          <SystemSetUp />
        )}
        {activeTab === 'alert' && (
          <AlertSetUp />
        )}
        {activeTab === 'alertTarget' && (
          <AlertTargetManagement />
        )}
      </div>
    </div>
  );
};

export default Settings; 